import React, { useState, useRef, useEffect, useContext } from 'react';
import type { Swiper as SwiperType } from 'swiper';
import SideBarLayout from '../../../global/layout/SideBarLayout';
import ImageInfoModal from './ImageInfoModal';
import ImageGridView from './ImageGridView';
import BottomThumbnailStrip from './BottomThumbnailStrip';
import ImageHeroSwiper from './ImageHeroSwiper';
import NoImage from './NoImage';
import DetailsHeaderTabs from '../locationDetail/DetailsHeaderTabs';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { makeDeleteCall, makeGetCall, makeNextPageCall, makePatchCall, makePostCall } from '../../../effects/requests';
import { endPoints } from '../../../utils/endpoints';
import { downloadWithWaterMark, emptyFunction, getCompanyName, handleTabs, showToast } from '../../../utils';
import { ApiResponseType } from '../../../types';
import { MyContext } from '../../../context';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../../../global/ui/Loader';
import { instance } from '../../../utils/axios';
import { UploadContext } from '../../../context/UploadContext';
import DeleteImagePopup from '../createLocation/DeleteImagePopup';
import ImageFullScreenViewer from '../../../global/ImageFullScreenViewer';
import UploadPhotoAndFolder from './UploadPhotoAndFolder';
import AsignLocationToCollection from '../collections/AsignLocationToCollection';
import CreateCollections from '../collections/CreateCollections';
import AsignLocationToPerScript from '../perScript/AsignLocationToPerScript';

const Dummy = () => (<div
    style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '18px',
        color: 'black',
        textAlign: 'center',
        width: '100%',
        padding: '0 16px',
        boxSizing: 'border-box',
        fontWeight: 600
    }}
>
    Coming Soon, Please visit <a
        href="https://www.sixthdegree.io/locations"
        target="_blank"
        rel="noopener noreferrer"
    >
        www.sixthdegree.io/locations
    </a> for locations already on baord.
</div>)

export type SubTab = 'info' | 'vault' | 'sixthdegree';

const LocationGallery: React.FC<any> = (props) => {

    const addPhotoRef = useRef<any>(null);

    const { userData } = useContext(MyContext);
    const { updateUploadProgress } = useContext(UploadContext);

    const params = useParams();
    const { state } = useLocation();
    const locationId = params?.id || '';
    const locationData = state?.location;
    const folderData = state?.folderData || null;
    const vaultType = params?.type || '';
    const navigate = useNavigate();
    const [topTab, setTopTab] = useState<any>('gallery');

    const [subTab, setSubTab] = useState<SubTab>('info');
    const [activeIndex, setActiveIndex] = useState(0);
    const [thumbsSwiper, setThumbsSwiper] = useState<SwiperType | null>(null);
    const [mainSwiper, setMainSwiper] = useState<SwiperType | null>(null);
    const [showInfoMenu, setShowInfoMenu] = useState(false);
    const [selectedFolder, setSelectedFolder] = useState<any>(folderData);
    const [showFolderDrop, setShowFolderDrop] = useState(false);
    const [isGridView, setIsGridView] = useState(false);
    const [viewerOpen, setViewerOpen] = useState(false);
    const [startIndex, setStartIndex] = useState(0);
    const [showUploadPhoto, setShowUploadPhoto] = useState(false);
    const [view, setView] = useState<any>('galleries');
    const [folderEntries, setFolderEntries] = useState<any>([]);
    const [showCreateCollection, setShowCreateCollection] = useState(false);
    const [asignLocCollection, setAsignLocCollection] = useState<any>(null);
    const [allFolders, setAllFolders] = useState([]);
    const [allImages, setAllImages] = useState([]);
    const [nextUrl, setNextUrl] = useState<string | null>(null);
    const [selectedImageId, setSelectedImageId] = useState<any>(null);
    const [currentPhoto, setCurrentPhoto] = useState<any>(null);
    const uploadRef = useRef<HTMLInputElement>(null);
    const total = allImages?.length;
    const [asignLocToScript, setAsignLocToScript] = useState<any>(null);

    // Reset to the first photo whenever the folder selection changes
    useEffect(() => {
        setActiveIndex(0);
        mainSwiper?.slideTo(0, 0);
        thumbsSwiper?.slideTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedFolder]);

    const getName = (url: any) => {
        const fileName = new URL(url)?.pathname?.split("/")?.pop();
        return fileName
    }

    const handleDownload = (photo: any) => {
        downloadWithWaterMark(photo?.image, userData, { location_vault_id: locationId, location_folder_image_id: photo?.id })
        setShowInfoMenu(false);
    }

    const onThumbnail = (photo: any, type: any) => {
        const fd: any = {
            folder_id: selectedFolder?.id || '',
            production_company_name: getCompanyName(userData),
            image_id: photo?.id || ''
        }
        if (type == 'image') {
            fd.thumbnail = true
        }
        if (type == 'location') {
            fd.location_thumbnail = true
        }

        makePatchCall(endPoints.LOCATION_FOLDER_IMAGE, fd).then(emptyFunction, emptyFunction)
    }

    const fetchFolders = () => {
        const url = `${endPoints.LOCATION_FOLDER}?location_id=${locationId || locationData?.location?.id || ''}`
        makeGetCall(url).then((res: ApiResponseType<any>) => {
            const list = res?.results?.length > 0 ? res?.results : []
            setAllFolders(res?.results);
            setNextUrl(res?.next || null);
            setAllImages(folderData ? folderData?.images : []);
            setSelectedFolder(folderData ? folderData : null);
            fillPredata(list)
        }).catch(emptyFunction)
    }

    const fetchMoreData = () => {
        if (!nextUrl) return;
        makeNextPageCall(nextUrl, false, true).then((res: ApiResponseType<any>) => {
            const data: any = [...allFolders, ...res.results];
            setAllFolders(data);
            setNextUrl(res?.next);
            fillPredata(data)
        })
    }

    useEffect(() => {
        if (userData?.id)
            fetchFolders();
    }, [userData?.id]);

    const makePostCallWithProgress = async (
        url: string,
        apiPayload: object = {},
        isToast: boolean = false,
        onUploadProgress?: (progressEvent: any) => void
    ) => {
        const response: ApiResponseType = await instance.post(url, apiPayload, {
            onUploadProgress,
            options: {
                hideGlobalLoader: true
            }
        });

        const statusCode = response?.status?.code;
        const message = response?.status?.message;

        if (message && isToast && statusCode === 200) {
            showToast(message, "success");
        }

        return response;
    };

    const createImages = async (imgEntries: Array<any>) => {

        const totalImages = imgEntries?.length || 0
        let completedImages = 0;

        // Show upload progress modal
        updateUploadProgress({
            uploading: true,
            visible: true,
            percentage: 0,
            uploaded: 0,
            total: totalImages,
            status: "uploading",
            message: "Preparing upload...",
        });

        try {
            const folderId = selectedFolder?.id;
            for (const image of imgEntries) {
                const fd = new FormData();
                fd.append("folder_id", folderId || '');
                fd.append("image", image.file);
                fd.append("production_company_name", getCompanyName(userData));
                fd.append("my_vault", vaultType == 'myvault' ? 'true' : 'false');

                const imageRes = await makePostCallWithProgress(
                    endPoints.LOCATION_FOLDER_IMAGE,
                    fd,
                    false,
                    (progressEvent) => {
                        if (!progressEvent.total) return;

                        const currentFileProgress = progressEvent.loaded / progressEvent.total;

                        const overallProgress = ((completedImages + currentFileProgress) / totalImages) * 100;

                        updateUploadProgress({
                            percentage: Math.round(overallProgress),
                            uploaded: completedImages,
                            message: `Uploading ${completedImages + 1} of ${totalImages}...`,
                        });
                    }
                );

                if (imageRes?.status?.code !== 200) {
                    throw new Error("Image upload failed.");
                }

                if (imageRes?.status?.code === 200) {
                    // @ts-ignore
                    setAllImages((prev) => [...prev, imageRes.data]);

                    setSelectedFolder((prev: any) =>
                        prev
                            ? {
                                ...prev,
                                images: [...(prev.images || []), imageRes.data],
                            }
                            : prev
                    );

                    setAllFolders((prev: any) =>
                        prev.map((folder: any) =>
                            folder.id === folderId
                                ? {
                                    ...folder,
                                    images: [...(folder.images || []), imageRes.data],
                                }
                                : folder
                        )
                    );
                }

                completedImages++;

                updateUploadProgress({
                    percentage: Math.round((completedImages / totalImages) * 100),
                    uploaded: completedImages,
                    message: `Uploaded ${completedImages} of ${totalImages}`,
                });
            }

            // Success state
            updateUploadProgress({
                uploading: false,
                percentage: 100,
                uploaded: totalImages,
                total: totalImages,
                status: "success",
                message: "Images uploaded successfully.",
            });

            // Wait 2 seconds so user can see success
            setTimeout(() => {
                updateUploadProgress({
                    uploading: false,
                    visible: false,
                    percentage: 0,
                    uploaded: 0,
                    total: 0,
                    status: "uploading",
                    message: "",
                });


            }, 3000);
        } catch (error: any) {

            updateUploadProgress({
                uploading: false,
                status: "error",
                message: error?.message || "Something went wrong while uploading.",
            });

            setTimeout(() => {
                updateUploadProgress({
                    uploading: false,
                    visible: false,
                    percentage: 0,
                    uploaded: 0,
                    total: 0,
                    status: "uploading",
                    message: "",
                });
            }, 3000);
        }
    };

    const handleUpload = (files: FileList | null) => {
        if (!files) return;

        const newPhotos = [];

        for (const file of Array.from(files)) {
            newPhotos.push({
                id: "",
                name: file?.name,
                image: URL.createObjectURL(file),
                file,
            });
        }

        if (uploadRef.current) uploadRef.current.value = "";

        if (newPhotos?.length > 0) {
            createImages(newPhotos)
        }
    };

    const handleRemovePhoto = () => {
        if (!selectedImageId) return;

        const url = `${endPoints.LOCATION_FOLDER_IMAGE}${selectedImageId}/`;

        makeDeleteCall(url)
            .then((res: ApiResponseType) => {
                if (res?.status?.code === 200) {
                    showToast(res.status.message, "success");

                    // Update image list
                    setAllImages(prev =>
                        prev.filter((image: any) => image.id !== selectedImageId)
                    );

                    // Update selected folder
                    setSelectedFolder((prev: any) => {
                        if (!prev) return prev;

                        return {
                            ...prev,
                            images: (prev.images || []).filter(
                                (image: any) => image.id !== selectedImageId
                            ),
                        };
                    });

                    // Update all folders
                    setAllFolders((prev: any) =>
                        prev.map((folder: any) =>
                            folder.id === selectedFolder?.id
                                ? {
                                    ...folder,
                                    images: (folder.images || []).filter(
                                        (image: any) => image.id !== selectedImageId
                                    ),
                                }
                                : folder
                        )
                    );

                    // Clear selection
                    setSelectedImageId(null);
                }
            })
            .catch(emptyFunction);
    };

    const moveItem = (from: number, to: number) => {
        // @ts-ignore
        setAllImages((prev: any) => {
            const updated = [...prev];
            const [removed] = updated.splice(from, 1);
            updated.splice(to, 0, removed);
            return updated;
        });
    };

    const createFolderAndImages = async (locationID: any) => {
        const totalImages = folderEntries.reduce(
            (count: number, folder: any) =>
                count + (folder.photos?.length || 0),
            0
        );

        let completedImages = 0;

        // Show upload progress modal
        updateUploadProgress({
            uploading: true,
            visible: true,
            percentage: 0,
            uploaded: 0,
            total: totalImages,
            status: "uploading",
            message: "Preparing upload...",
        });

        try {
            for (const folder of folderEntries) {
                let folderId = '', folderRes: any = {};
                if (!folder?.isExistingFolder) {
                    const folderPayload = {
                        location_id: locationID,
                        name: folder.name || "",
                        production_company_name: getCompanyName(userData),
                    };

                    folderRes = await makePostCall(
                        endPoints.LOCATION_FOLDER,
                        folderPayload
                    );



                    if (folderRes?.status?.code !== 200) {
                        throw new Error("Folder creation failed.");
                    }
                    folderId = folderRes?.data?.id;
                } else {
                    folderId = folder?.id;
                }

                for (const image of folder.photos) {
                    const fd = new FormData();

                    fd.append("folder_id", folderId);
                    fd.append("image", image.file);
                    fd.append(
                        "production_company_name",
                        getCompanyName(userData)
                    );
                    fd.append("thumbnail", image?.thumbnail || false);

                    const imageRes = await makePostCallWithProgress(
                        endPoints.LOCATION_FOLDER_IMAGE,
                        fd,
                        false,
                        (progressEvent) => {
                            if (!progressEvent.total) return;

                            const currentFileProgress =
                                progressEvent.loaded /
                                progressEvent.total;

                            const overallProgress =
                                (
                                    (completedImages +
                                        currentFileProgress) /
                                    totalImages
                                ) * 100;

                            updateUploadProgress({
                                percentage: Math.round(overallProgress),
                                uploaded: completedImages,
                                message: `Uploading ${completedImages + 1} of ${totalImages}...`,
                            });
                        }
                    );

                    if (imageRes?.status?.code !== 200) {
                        throw new Error("Image upload failed.");
                    }

                    completedImages++;

                    updateUploadProgress({
                        percentage: Math.round(
                            (completedImages / totalImages) * 100
                        ),
                        uploaded: completedImages,
                        message: `Uploaded ${completedImages} of ${totalImages}`,
                    });
                }
            }

            // Success state
            updateUploadProgress({
                uploading: false,
                percentage: 100,
                uploaded: totalImages,
                total: totalImages,
                status: "success",
                message: "Images uploaded successfully.",
            });

            // Wait 2 seconds so user can see success
            setTimeout(() => {
                updateUploadProgress({
                    uploading: false,
                    visible: false,
                    percentage: 0,
                    uploaded: 0,
                    total: 0,
                    status: "uploading",
                    message: "",
                });

                setFolderEntries([]);
                setView('galleries');
                fetchFolders();

                // Refresh your list if required
                // fetchFolders();

                // Clear local data if required
                // setFolderEntries([]);
            }, 3000);
        } catch (error: any) {
            console.error(error);

            updateUploadProgress({
                uploading: false,
                status: "error",
                message: error?.message || "Something went wrong while uploading.",
            });

            setTimeout(() => {
                updateUploadProgress({
                    uploading: false,
                    visible: false,
                    percentage: 0,
                    uploaded: 0,
                    total: 0,
                    status: "uploading",
                    message: "",
                });
            }, 3000);
        }
    };

    const handleDone = () => {
        if (view == 'new-folder') {
            addPhotoRef?.current?.handleCreateFolder();
            return
        }
        if (allFolders?.length <= 0) {
            showToast("Please add at least one folder and images.", 'error');
            return;
        }
        createFolderAndImages(locationId);
        setShowUploadPhoto(false);
    }

    const resetCreate = () => {
        setShowUploadPhoto(false);
        setFolderEntries([]);
        setView('galleries')
    }

    const fillPredata = (mainList: Array<any>) => {
        const list = mainList?.map((item: any) => ({
            ...item,
            photos: Array.isArray(item?.images) && item?.images?.length > 0
                ? item?.images?.map((image: any) => ({
                    ...image,
                    isImageExist: true,
                }))
                : [],
            isExistingFolder: true,
        }));

        setFolderEntries(list);
    }

    return (
        <SideBarLayout>
            <div className="right-content-full-screen">
                <div className="ld-page ">

                    <div className="ld-header">
                        <div className="ld-header__left">
                            <h1 className="ld-header__title">{selectedFolder?.name || ''}</h1>
                            <div className="ld-breadcrumb">
                                <button className="ld-breadcrumb__link" onClick={() => navigate(vaultType === 'myvault' ? '/location/myvault' : '/location/vault')}>
                                    {vaultType === 'myvault' ? "My Vault" : 'Location Vault'}
                                </button>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                                <button
                                    className="ld-breadcrumb__link"
                                    onClick={() => {
                                        navigate(`/location-folders/${vaultType}/${locationId}`, {
                                            state: { location: locationData },
                                        })
                                    }}>
                                    {locationData?.name}
                                </button>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                                <span className="ld-breadcrumb__current">{selectedFolder?.name || ''}</span>
                            </div>
                        </div>

                        <DetailsHeaderTabs
                            setTopTab={(type: any) => {
                                const route = handleTabs(type);
                                setTopTab(type)
                                if (route) {
                                    navigate(`${route}/${vaultType}/${locationId}`, {
                                        replace: true,
                                        state: { location: locationData },
                                    });
                                }
                            }}
                            topTab={topTab}
                        />

                        <div className="ld-header__actions">
                            {!props?.hideAsign &&
                                <>
                                    <button
                                        type='button'
                                        onClick={() => {
                                            setAsignLocCollection({ location: locationData, id: locationId })
                                        }}
                                        className="ld-btn-assign"
                                    >
                                        Assign Location
                                    </button>
                                    {props?.vaultType != 'myvault' &&
                                        <button
                                            type='button'
                                            onClick={() => {
                                                setAsignLocToScript({ location: locationData, id: locationId })
                                            }}
                                            className="ld-btn-assign"
                                        >
                                            Assign to script
                                        </button>
                                    }
                                </>
                            }
                            <button
                                type='button'
                                onClick={() => {
                                    showToast('coming soon.', 'info')
                                }}
                                className="ld-btn-icon"
                                aria-label="Share"
                            >
                                <img src="/assets/images/upload-share-icon.svg" alt="Share" />
                            </button>
                        </div>
                    </div>

                    <div className="la-wrap">
                        <div className="la-subtabs-bar">
                            <div className="la-subtabs">
                                <button
                                    className={`la-subtab${subTab === 'info' ? ' la-subtab--active' : ''}`}
                                    onClick={() => setSubTab?.('info')}
                                >
                                    Production Photos
                                </button>
                                <button
                                    className={`la-subtab${subTab === 'vault' ? ' la-subtab--active' : ''}`}
                                    onClick={() => setSubTab?.('vault')}
                                >
                                    Location Vault
                                </button>
                                <button
                                    className={`la-subtab${subTab === 'sixthdegree' ? ' la-subtab--active' : ''}`}
                                    onClick={() => setSubTab?.('sixthdegree')}
                                >
                                    6th Degree Photos
                                </button>
                            </div>

                            <div className="la-subtabs-action">
                                <div className="lg-bar__right">
                                    <div className="lg-folder-wrap">
                                        <button
                                            type='button'
                                            onClick={e => {
                                                e.stopPropagation();
                                                if (!selectedFolder?.id) return
                                                setShowFolderDrop(p => !p);
                                            }}
                                            className="la-btn-action"
                                        >
                                            <img width={15} height={15} src='/assets/images/folders.svg' alt='folder' />
                                            <span className='la-btn-action__span'>{selectedFolder?.name || ''}</span>
                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round">
                                                <polyline points="6 9 12 15 18 9" />
                                            </svg>
                                        </button>
                                        {showFolderDrop && (
                                            <div id='scrollableId' className="lg-folder-dropdown">
                                                <InfiniteScroll
                                                    dataLength={allFolders?.length}
                                                    next={fetchMoreData}
                                                    hasMore={nextUrl ? true : false}
                                                    loader={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Loader imgStyle={{ width: '40px', height: '40px' }} /></div>}
                                                    scrollableTarget="scrollableId"
                                                >
                                                    {allFolders?.map((f: any) => (
                                                        <button
                                                            key={f?.id}
                                                            className={`lg-folder-option${selectedFolder?.id === f?.id ? ' lg-folder-option--active' : ''}`}
                                                            onClick={() => {
                                                                setSelectedFolder(f);
                                                                setAllImages(f?.images?.length > 0 ? f?.images : [])
                                                                setShowFolderDrop(false);
                                                            }}
                                                        >
                                                            <span className="lg-folder-option__check">
                                                                {selectedFolder?.id === f?.id && (
                                                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                                                        <polyline points="20 6 9 17 4 12" />
                                                                    </svg>
                                                                )}
                                                            </span>
                                                            <span className="lg-folder-option__label">{f?.name || ''}</span>
                                                            <span className="lg-folder-option__count">{f?.images?.length || 0}</span>
                                                        </button>
                                                    ))}
                                                </InfiniteScroll>
                                            </div>
                                        )}
                                    </div>
                                    {(selectedFolder?.id && locationData?.role != 'V') &&
                                        <button
                                            type='button'
                                            // onClick={() => {
                                            //     setShowUploadPhoto(true)
                                            //     fillPredata(allFolders);
                                            // }}
                                            onClick={() => uploadRef.current?.click()}
                                            className="la-btn-action"
                                        >
                                            <img src='/assets/images/upload-icon.svg' />
                                            Upload photos
                                        </button>
                                    }
                                    <input
                                        ref={uploadRef}
                                        type="file"
                                        accept="image/*"
                                        multiple
                                        hidden
                                        onChange={(e) => handleUpload(e.target.files)}
                                    />
                                    <div className="lv-view-btn-wrap">
                                        <button
                                            className={`lv-view-toggle-btn ${isGridView ? "active" : ""}`}
                                            onClick={() => setIsGridView(true)}
                                        >
                                            <img src={isGridView ? '/assets/images/grid-view-active.svg' : '/assets/images/grid-view.svg'} />
                                        </button>

                                        <button
                                            className={`lv-view-toggle-btn ${!isGridView ? "active" : ""}`}
                                            onClick={() => setIsGridView(false)}
                                        >
                                            <img src={!isGridView ? '/assets/images/list-view-active.svg' : '/assets/images/list-view.svg'} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {subTab == 'vault' || subTab == 'sixthdegree'
                        ?
                        <Dummy />
                        :
                        <>
                            {total === 0
                                ?
                                <NoImage selectedFolder={selectedFolder} />
                                :
                                <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                                    {
                                        isGridView
                                            ?
                                            <>
                                                <ImageHeroSwiper
                                                    thumbsSwiper={thumbsSwiper}
                                                    setMainSwiper={setMainSwiper}
                                                    setActiveIndex={setActiveIndex}
                                                    filteredPhotos={allImages}
                                                    setShowInfoMenu={setShowInfoMenu}
                                                    showInfoMenu={showInfoMenu}
                                                    handleDownload={handleDownload}
                                                    activeIndex={activeIndex}
                                                    total={total}
                                                    onInfo={setCurrentPhoto}
                                                    handleDelete={(img: any) => setSelectedImageId(img?.id)}
                                                    mainSwiper={mainSwiper}
                                                    onThumbnail={onThumbnail}
                                                    locationData={locationData}
                                                />

                                                <BottomThumbnailStrip
                                                    setThumbsSwiper={setThumbsSwiper}
                                                    filteredPhotos={allImages}
                                                    activeIndex={activeIndex}
                                                    mainSwiper={mainSwiper}
                                                />

                                                <div className="lg-progress">
                                                    <div
                                                        className="lg-progress__bar"
                                                        style={{ width: `${((activeIndex + 1) / total) * 100}%` }}
                                                    />
                                                </div>
                                            </>
                                            :
                                            <ImageGridView
                                                filteredPhotos={allImages}
                                                onDownload={handleDownload}
                                                onInfo={setCurrentPhoto}
                                                onDelete={(img: any) => setSelectedImageId(img?.id)}
                                                moveItem={moveItem}
                                                onViewImg={(img: any, index: any) => {
                                                    setStartIndex(index || 0)
                                                    setViewerOpen(true);
                                                }}
                                                folderId={selectedFolder?.id}
                                                onThumbnail={onThumbnail}
                                                locationData={locationData}
                                            />
                                    }
                                </div>
                            }
                        </>
                    }

                    {/* Info modal */}
                    {currentPhoto && (
                        <ImageInfoModal
                            photo={currentPhoto}
                            onClose={() => setCurrentPhoto(null)}
                            selectedFolder={selectedFolder}
                        />
                    )}

                    {selectedImageId &&
                        <DeleteImagePopup
                            onClose={() => setSelectedImageId(null)}
                            onDelete={handleRemovePhoto}
                        />
                    }

                    {viewerOpen &&
                        <ImageFullScreenViewer
                            isOpen={viewerOpen}
                            images={allImages}
                            initialIndex={startIndex}
                            onClose={() => setViewerOpen(false)}
                            onDownload={handleDownload}
                            onInfo={setCurrentPhoto}
                            onDelete={(img: any) => setSelectedImageId(img?.id)}
                        />
                    }

                </div>

                {showUploadPhoto &&
                    <UploadPhotoAndFolder
                        setFolderEntries={setFolderEntries}
                        folderEntries={folderEntries}
                        setView={setView}
                        fetchFolders={fetchFolders}
                        view={view}
                        ref={addPhotoRef}
                        onClose={resetCreate}
                        onDone={handleDone}
                    />
                }

                {showCreateCollection &&
                    <CreateCollections
                        onClose={() => setShowCreateCollection(false)}
                        onDone={() => {
                            setShowCreateCollection(false)
                        }}
                    />
                }

                {asignLocCollection?.id &&
                    <AsignLocationToCollection
                        onClose={() => setAsignLocCollection(null)}
                        onCreate={() => {
                            setAsignLocCollection(null);
                            setShowCreateCollection(true)
                        }}
                        locationData={asignLocCollection}
                        production_company_name={getCompanyName(userData)}
                    />
                }

                {asignLocToScript?.id &&
                    <AsignLocationToPerScript
                        onClose={() => setAsignLocToScript(null)}
                        onCreate={() => {
                            setAsignLocToScript(null);
                        }}
                        locationData={asignLocToScript}
                        production_company_name={getCompanyName(userData)}
                    />
                }

            </div>
        </SideBarLayout>
    );
};

export default LocationGallery;